define.alias("ember-basic-dropdown/components/basic-dropdown", "settings/components/basic-dropdown");